import React from 'react';

export interface OffersTrackingLevel {
  readonly levelName: string; // ModelLevel;
  readonly levelNumber: number;
}

export interface TrackingContextValue {
  readonly currentLevel?: OffersTrackingLevel;
}

export const TrackingContext = React.createContext<TrackingContextValue>({});
